import React from "react";
import { Row, Col } from "antd";
import { backArrowIcon } from "../../assets/images";
import CustomButton from "../../common/Buttons/CustomButton";
import PersonForm from "./Forms/PersonForm";
import { PersonType } from "../../types/PersonTypes";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";
import moment from "moment";
import { usePersonFormBackNavigation } from "../../hooks/usePersonFormBackNavigation";
import { RegistrationEnums } from "../../types/ApplicationTypes";
import {
  getBackPersonFormValues,
  getInitialAddress,
} from "../../helpers/personHelpers";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";
import { useServiceUserCreationCtx } from "../../context/ServiceUserCreationContext";

function Myself() {
  const { caregiverSummaryInfo, isLoadingPersonData } = usePersonSummaryCtx();
  const { navigateBack } = usePersonFormBackNavigation();

  const {
    registrationBackBtnClickCtx,
    serviceUserMyselfDetailsCtx,
  } = useServiceUserCreationCtx();
  const [serviceUserMyselfDetails] = serviceUserMyselfDetailsCtx;
  const [isBackBtnClick] = registrationBackBtnClickCtx;

  const {
    firstName,
    lastName,
    primaryPhone,
    wandaEmail,
    dateOfBirth,
    homeAddress,
    mailingAddress,
    imageUrl,
  } = caregiverSummaryInfo;

  function getInitialValues() {
    const initialValues = {
      firstName: firstName,
      lastName: lastName,
      phone: primaryPhone,
      email: wandaEmail,
      dateOfBirth:
        moment.utc(dateOfBirth).format("YYYY-MM-DD") ===
        RegistrationEnums.DateOfBirth
          ? undefined
          : moment.utc(dateOfBirth),
      isSameAsHomeAddress:
        JSON.stringify(homeAddress) === JSON.stringify(mailingAddress),
      homeAddress: getInitialAddress(homeAddress),
      mailingAddress: getInitialAddress(mailingAddress),
      photo: imageUrl,
      wandaAccommodations: {
        wheelChairTravel: false,
        wheelChairPresent: false,
        wcToVehicleTransfer: false,
      },
    };

    if (isBackBtnClick) {
      return serviceUserMyselfDetails
        ? getBackPersonFormValues(serviceUserMyselfDetails)
        : initialValues;
    } else {
      return initialValues;
    }
  }

  return isLoadingPersonData ? (
    <GoogleLoader />
  ) : (
    <Row>
      <Col xs={2} lg={4} />
      <Col xs={20} lg={16}>
        <CustomButton
          text="Back"
          handlerFunction={navigateBack}
          type="link"
          icon={backArrowIcon}
          className="backBtn"
        />
        <PersonForm
          personType={PersonType.Myself}
          initialValues={getInitialValues()}
        />
      </Col>
      <Col xs={2} lg={4} />
    </Row>
  );
}

export default Myself;
